export default __webpack_public_path__ + "media/images/theme/bg_dark-43947afe0271cefbfd49d4f753d424f2.png";